<template>
<div>
  <div class="content" style="width: auto">
    <div class="cont-list">
      <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
    </div>

    <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
      <div class="edit-card">
        <div style="width: 88%; display: flex">
          <div class="start-label" />
          <span class="text">基础信息</span>
        </div>
        <el-row>
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="no" label="申请单号" v-if="getIsView()">
              <el-input disabled v-model="form.no"></el-input>
            </el-form-item>
            <span class="viewText" v-else>申请单号:{{ form.no }} </span>
          </el-col>
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item label="申请时间" prop="createdTime" v-if="getIsView()">
              <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
              </el-date-picker>
            </el-form-item>
            <span class="viewText" v-else>申请时间:{{ parseTime(new Date(form.createdTime) ,"{y}-{m}-{d} {h}:{i}:{s}") }} </span>
          </el-col>
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="createdUserName" label="申请人" v-if="getIsView()">
              <el-input disabled v-model="form.createdUserName"></el-input>
            </el-form-item>
            <span class="viewText" v-else>申请人:{{ form.createdUserName }} </span>
          </el-col>
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
              <el-input disabled v-model="form.ownerDeptName"></el-input>
            </el-form-item>
            <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="warehouseName" label="备货仓库" v-if="getIsView()">
              <el-select v-model="form.warehouseName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getWarehousesBySessionWarehouseId" @change="warehouseChange">
                <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <span class="viewText" v-else>备货仓库:{{ form.warehouseName }} </span>
          </el-col>
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="warehouseManagerId" label="库管员" v-if="getIsView()">
              <el-input disabled v-model="form.warehouseManagerName"></el-input>
            </el-form-item>
            <span class="viewText" v-else>库管员:{{ form.warehouseManagerName }} </span>
          </el-col>

          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="applyDeptName" label="备货科室" v-if="getIsView()">
              <el-select v-if="system_setting.IsUseWard" v-model="form.applyDeptName" placeholder="请选择"
              :disabled="!editMode" style="width: 100%" filterable
                :filter-method="getDeptAndWards" @change="applyDeptChange1">
                <el-option v-for="item in STATIC_DeptAndWards" :key="item.idGroup"
                  :label="item.deptNo+' '+item.deptName + ' ' + (item.wardName ? item.wardName : '')" :value="item.idGroup"></el-option>
              </el-select>
              <el-select v-else v-model="form.applyDeptName" placeholder="请选择"
              :disabled="!editMode" style="width: 100%" filterable :filter-method="getDepts"
                @change="applyDeptChange">
                <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <span class="viewText" v-else>备货科室:{{ form.applyDeptName }} </span>
          </el-col>

          
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="oneLevelWarehouseId" label="收货库房" v-if="getIsView()">
              <el-select v-model="form.oneLevelWarehouseName" :disabled="!editMode && !approveDisable" placeholder="请选择收货库房" style="width: 100%" filterable :filter-method="getOneLevelWarehouses" @change="oneLevelWarehouseChange">
                <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <span class="viewText" v-else>收货库房:{{ form.oneLevelWarehouseName }} </span>
          </el-col>
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
          <el-form-item prop="pressingState" label="紧急标识" v-if="getIsView()">
            <el-select v-model="form.pressingState" :disabled="!editMode" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in OrderPressingOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <span class="viewText" v-else>紧急标识:{{ OrderPressingOptions.find(item => item.id === form.pressingState)?.name }} </span>
        </el-col>
      
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
              <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
            </el-form-item>
          <span class="viewText" v-else>总数量:{{ form.totalNumber }} </span>
          </el-col>
      
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
              <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
            </el-form-item>
          <span span class="viewText" v-else>总金额:{{ form.totalAmount }} </span>
          </el-col>
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item label="备注" prop="remark" v-if="getIsView()">
              <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
            </el-form-item>
          <span class="viewText" v-else>备注:{{ form.remark }} </span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px"></el-row>
      </div>

      <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
        <div style="width: 88%; display: flex">
          <div class="start-label" />
          <span class="text">申请明细</span>
        </div>

        <div v-if="editMode" style="margin: 20px 0 12px 10px">
          <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
          <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
        </div>
        <div v-else style="margin-top: 20px"></div>

        <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <el-table-column type="index" width="50" fixed> </el-table-column>
          <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
          <el-table-column prop="productName" label="产品" width="180" fixed></el-table-column>
          <el-table-column show-overflow-tooltip prop="specName" label="产品规格" fixed width="160"></el-table-column>
          <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
          <el-table-column prop="pressingStateName" width="80" label="紧急标识"></el-table-column>

          <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证" width="130"></el-table-column>
          <el-table-column prop="unit" label="包装单位" width="120"></el-table-column>
          <el-table-column prop="minUnit" label="最小单位" width="120"></el-table-column>
          <el-table-column prop="stockNumber" label="库存数量" width="120"></el-table-column>
          <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
          <el-table-column prop="number" label="数量" width="120"></el-table-column>
          <el-table-column prop="price" label="单价" width="120"></el-table-column>
          <el-table-column prop="amount" label="小计" width="120"></el-table-column>
          <el-table-column prop="limitNumber" label="限额可领数量" width="120"></el-table-column>
          <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="180"></el-table-column>
          <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号" width="130"></el-table-column>
          <el-table-column prop="productCode" label="商品代码" width="100"></el-table-column>
          <el-table-column prop="newProductId"  label="平台产品id" width="100"></el-table-column>
          <el-table-column prop="minPrice" v-if="this.system_setting.isUsePriceMonitor" label="平台最低价" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="70"></el-table-column>
          <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
          <el-table-column prop="remark" label="备注" width="200"></el-table-column>
        </el-table>
      </div>

      <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
    </el-form>

    <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="supplierProductNo" label="供应商产品编码">
              <el-input disabled v-model="childForm.supplierProductNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称" prop="productName">
              <SelectTable :disabled="!editMode" :columns="supplierProductColumns2" :placeholder="'请选择产品'" :innerName="childForm.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList" @change="productChange" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="specName" label="规格型号">
              <el-input disabled v-model="childForm.specName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="productRegistCertName" label="产品注册证">
              <el-input disabled v-model="childForm.productRegistCertName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="productRegistCertNo" label="注册证号">
              <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="supplierName" label="供应商">
              <el-input disabled v-model="childForm.supplierName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="manufacturerName" label="生产厂家">
              <el-input disabled v-model="childForm.manufacturerName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="onlineNo" label="挂网号">
              <el-input disabled v-model="childForm.onlineNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="brand" label="品牌">
              <el-input disabled v-model="childForm.brand"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="unit" label="包装单位">
              <el-input disabled v-model="childForm.unit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="minUnit" label="最小单位">
              <el-input disabled v-model="childForm.minUnit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="packSpec" label="包装规格">
              <el-input :disabled="!editMode" v-model="childForm.packSpec"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="stockNumber" label="库存数量">
              <el-input disabled v-model="childForm.stockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="number" label="数量">
              <!-- <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number> -->
              <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="childNumberChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="price" label="单价">
              <el-input disabled v-model="childForm.price"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="amount" label="小计">
              <el-input disabled v-model="childForm.amount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="remark" label="备注">
              <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="limitNumber" label="限额可领数量">
              <el-input disabled v-model="childForm.limitNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
              <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
        <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
  <div slot="footer" class="footer-bottom">
    <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
    <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
    <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
    <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
    <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
  </div>
</div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetStockUpApplyById,
  SaveStockUpApply,
  RejectStockUpApply,
  GetStockNumber,
} from "@/api";
import {
  InStockOptions,
  WhetherOptions,
  AssetSourceOptions,
  OrderPressingOptions,
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data() {
    return {
      GetDataAction: GetStockUpApplyById,
      SaveDataAction: SaveStockUpApply,
      reject: RejectStockUpApply,

      form: {},
      InStockOptions: InStockOptions,
      WhetherOptions: WhetherOptions,
      AssetSourceOptions: AssetSourceOptions,
      OrderPressingOptions: OrderPressingOptions,
      rules: {
        warehouseName: [{
          required: true,
          message: "请选择备货仓库",
          trigger: "blur"
        }],
        oneLevelWarehouseId: [{
          required: true,
          message: "请选择收货库房",
          trigger: "blur"
        }, ],
        applyDeptName:[{
          required: true,
          message: "请选择备货科室",
          trigger: "blur"
        }, ],
        pressingState: [{
          required: true,
          message: "请选择紧急标识",
          trigger: "blur"
        }, ],
      },
      childFormRules: {
        productName: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        price: [{
          required: true,
          message: "请输入采购价",
          trigger: "blur"
        }],
        number: [{
            required: true,
            message: "数量不能为空",
            trigger: "blur"
          },
          // {
          //   type: "number",
          //   min: 0.01,
          //   message: "数量必须大于0",
          //   trigger: "blur",
          // },
          // {
          //   validator: this.validateLimitNumber,
          //   trigger: "blur"
          // },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      // showCapitalSource: false,
      // showCapitalSourceTwo: false,
      // showCapitalSourceThree: false,
      capitalSourcemaxCount: 0,
      // fileId: 0,
      // fileName: '',
      // openViewer: false,
      isCopy: false,
      approveDisable: false,
    };
  },

  created() {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (query.isCopy == 1) {
      this.isCopy = true;
    }

    if (this.system_setting.IsUseWard) {
      this.getDeptAndWards()

    } else {
      this.getDepts("");
    }
    // if (query.editMode == 1) {
    //   this.editMode = true
    // }

    this.getWarehousesBySessionWarehouseId("");
    this.getProductList("");
    this.getOneLevelWarehouses("");
  },
  methods: {
    // 新建
    handleAdd() {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate(id) {
      this.GetDataAction({
        id
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        if (
          this.formMode == 3 &&
          this.form.status == 1 &&
          this.form.approverIds &&
          this.form.approverIds.indexOf(this.userInfo.id + "") != -1
        ) {
          this.approveDisable = true;
        }
        if (this.isCopy) {
          this.form.id = 0;
          this.form.no = "";
          this.form.status = 2;
          this.form.applyStatus = 0;
          this.form.state = 0;
          this.form.workFlowInstanceId = 0;
          let now = this.parseTime(new Date());
          let user = this.userInfo;
          this.form.createdUserName = user.name;
          this.form.createdUser = user.id;
          this.form.ownerDept = user.deptId;
          this.form.ownerDeptName = user.deptName;
          this.form.createdTime = now;

          if (this.form.details) {
            this.form.details.map((item) => {
              // item.receivedNumber = 0
              // item.notReceivedNumber = item.number
              // item.state = 0
              // item.stateName = ''
              GetStockNumber({
                supplierProductId: item.supplierProductId,
                warehouseId: this.form.warehouseId,
              }).then((res) => {
                this.form.details = this.form.details.map((detail) => {
                  if (item.$index == detail.$index) {
                    detail.stockNumber = res.returnData.stockNumber;
                  }
                  return detail;
                });
              });

              return item;
            });
          }
        }
      });
    },
    // 保存
    submit() {
      this.$store.dispatch('SetLoading',true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(
            this.getMainPath(this.$route.path),
            this.$route.params
          );
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm() {
      this.form = {
        inStockType: 0,
        supplierId: "",
        supplierName: "",
        assetCheckNo: "",
        assetCheckId: "",
        state: 0,
        details: [],
        pressingState:0,
        warehouseCategory: "",
        warehouseId: "", //this.userInfo.defaultWarehouseId,
        warehouseName: "", //this.userInfo.defaultWarehouseName,
        warehouseManagerId: "", //this.userInfo.defaultWarehouseManagerId,
        warehouseManagerName: "", //this.userInfo.defaultWarehouseManagerName,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        applyDeptName: this.system_setting.IsUseWard?`${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} `:this.mySessionStorage.getDeptName(),
        wardId:this.mySessionStorage.getWardId(),
        applyDeptId: this.mySessionStorage.getDeptId(),
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
      this.setDefaultWarehouseBySessionWarehouseId();
    },
    // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm() {
      if(this.form.applyDeptId){
        this.openSubformModal = true;
        this.editChildren = false;
        this.resetDetailFormData();

        this.getProductList("");
      }else{
        this.$my_message('请选择备货科室!','warning')
      }
    
    },
    handleDeleteChildForm() {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange(selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick(row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },

    resetDetailFormData() {
      this.childForm = {
        $index: this.form.details.length + 1,
        supplierProductId: "",
        productName: "",
        productId: "",
        specId: "",
        brand: "",
        supplierId: "",
        manufacturerId: "",
        unit: "",
        minUnit: "",
        stockNumber: 0,
        oneLevelStockNumber: 0,
        number: 0,
        price: 0,
        amount: 0,
        limitNumber: "",
        remark: "",
        isHaveStock: true,
        packSpec: "",
      };
    },
    cancelChildDialog() {
      this.openSubformModal = false;
    },
    submitChildForm() {
      this.pushChildForm(true);
    },
    continueAdd() {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList("");
    },

    applyDeptChange1 (val) {
      let arr = this.STATIC_DeptAndWards.filter(res => res.idGroup == val)
      this.form.applyDeptName = arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
      this.form.applyDeptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
    },
    applyDeptChange (val) {
      this.form.applyDeptId = val
    },

    pushChildForm(close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
          e.$index != this.childForm.$index &&
          e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find((e) => e.$index == this.childForm.$index);
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange() {
      this.childForm.notReceivedNumber = this.childForm.number;
      this.childForm.planOrderNumber = this.childForm.number;
      this.childForm.actualOrderNumber = this.childForm.number;
      this.autoAmount();
    },
    autoAmount() {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount() {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // change event
    warehouseChange(val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
        this.form.warehouseCategoryName = item.category == 1 ? "一级库房" : "二级库房";
        this.form.warehouseCategory = item.category;
      }
    },
    oneLevelWarehouseChange(val) {
      this.form.oneLevelWarehouseId = val;
      let arr = this.STATIC_OneLevelWarehouses.filter((item) => item.id == val);
      this.form.oneLevelWarehouseManagerId = arr ? arr[0].managerId : "";
    },
    productChange(row) {
      let id = this.childForm.id;
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      console.log(row);
      
      this.childForm = Object.assign(this.childForm, row); // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      this.childForm.id = id;
      this.childForm.supplierProductId = row.id;
      this.childForm.number = 1;
      // this.childForm.receivedNumber = 0
      // this.childForm.notReceivedNumber = 1
      // this.childForm.planOrderNumber = 1
      // this.childForm.actualOrderNumber = 1
      this.childForm.price = this.childForm.purchasePrice;
      this.childForm.amount = this.childForm.price;
      this.childForm.supplierProductNo = this.childForm.no;
      this.childForm.remark = "";

      setTimeout(() => {
        this.$refs.number.focus();
        this.$refs.number.select();
      }, 1);

      this.$refs.childForm.validateField("productName");

      this.childForm.stockNumber = 0;
      GetStockNumber({
        supplierProductId: row.id,
        warehouseId: this.form.warehouseId,
      }).then((res) => {
        this.childForm.stockNumber = res.returnData.stockNumber;
      });
    },

    getProductList(keyWord) {
      // query.pageIndex = 1
      // query.pageSize = 100
      // query.isEnabled = 1
      // query.supplierId = this.form.supplierId
      // query.deptId = this.userInfo.deptId
      // query.stockCategory = 1
      // query.status = 2

      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          pageIndex: 1,
          pageSize: 100,
          isEnabled: 1,
          supplierId: this.form.supplierId,
          deptId: this.form.applyDeptId,
          stockCategory: 1,
          status: 2,
          supplierApproveStates: [2],
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
